exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".GIS_Client #map {\r\n    bottom: 0;\r\n}\r\n\r\n.GIS_Client .map-logo{\r\n\tbottom:5px;\r\n}\r\n\r\n.GIS_Client #navigationBar .mapToolbar {\r\n    bottom: 25px;\r\n    margin-bottom: 0;\r\n}\r\n\r\n.GIS_Client .background-plugin-position {\r\n    bottom: 20px;\r\n    margin-bottom: 0;\r\n}\r\n\r\n.GIS_Client .leaflet-control-attribution {\r\n    background-color: transparent;\r\n}\r\n\r\n.GIS_Client .ol-attribution.ol-uncollapsible {\r\n    background-color: transparent;\r\n}\r\n", ""]);

// exports
